import { toItem as toFile } from '../../private-site/mappers/item';
import { toFolder } from '../../private-site/mappers/folder';
import { ItemKind } from '../../../constants/ItemKind';
import { sendInvalidBoardItemEvent } from '../bi';
const getItemMapper = kind => {
  switch (kind) {
    case ItemKind.File:
      return toFile;
    case ItemKind.Folder:
      return toFolder;
    case 'external':
    case 'public':
      return srcInfo => ({
        ...srcInfo,
        tags: [...(srcInfo.tags || []), '_fav']
      });
    default:
      return null;
  }
};
export function toItem(itemData, settings, thumbnailSizes) {
  const mapper = getItemMapper(itemData.src_type);
  if (!mapper) {
    sendInvalidBoardItemEvent({
      srcType: itemData.src_type,
      itemId: itemData.id
    });
    return null;
  }
  return {
    id: itemData.id,
    ...(itemData.src_info ? mapper(itemData.src_info, settings, thumbnailSizes) : {}),
    siteMediaToken: itemData.token
  };
}